module.exports = __webpack_public_path__ + "img/bean_gift.85a77500.png";